'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DateValidator = exports.DateRule = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _validator = require('validator');

var _validator2 = _interopRequireDefault(_validator);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _Any = require('./Any');

var _helpers = require('../helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var formatErrorDate = function formatErrorDate(date) {
  return (0, _moment2.default)(date, 'YYYY-MM-DD').format('MMM Do, YYYY');
};

/****************************************
  Rule Builder
*****************************************/

var DateRule = function (_AnyRule) {
  _inherits(DateRule, _AnyRule);

  function DateRule(rules) {
    var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'YYYY/MM/DD';
    var message = arguments[2];

    _classCallCheck(this, DateRule);

    // If this object is being made for the first time (and not chained as `setRule` does below)
    var _this = _possibleConstructorReturn(this, (DateRule.__proto__ || Object.getPrototypeOf(DateRule)).call(this, rules));

    if (!_this.getRule('type')) {
      _this.rules.type = (0, _helpers.cleanObject)({ rule: 'date', format: format, message: message });
    }
    return _this;
  }

  _createClass(DateRule, [{
    key: 'setRule',
    value: function setRule(ruleName, rule) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      if (typeof ruleName !== 'string') throw new Error('`ruleName` argument should be a string');

      // Ensure format gets passed along to the next instance of new DateRule
      var format = this.rules.type.format;


      return new DateRule(Object.assign({}, this.toJSON(), _defineProperty({}, ruleName, Object.assign({}, options, { rule: rule, format: format }))));
    }
  }, {
    key: 'isSame',
    value: function isSame(date, message) {
      if (!(0, _moment2.default)(date, 'YYYY-MM-DD', true).isValid()) throw new Error('`isSame` expects date in YYYY-MM-DD format');
      return this.setRule('isSame', date, (0, _helpers.cleanObject)({ message: message }));
    }
  }, {
    key: 'isSameOrBefore',
    value: function isSameOrBefore(date, message) {
      if (!(0, _moment2.default)(date, 'YYYY-MM-DD', true).isValid()) throw new Error('`isSameOrBefore` expects date in YYYY-MM-DD format');
      return this.setRule('isSameOrBefore', date, (0, _helpers.cleanObject)({ message: message }));
    }
  }, {
    key: 'isSameOrAfter',
    value: function isSameOrAfter(date, message) {
      if (!(0, _moment2.default)(date, 'YYYY-MM-DD', true).isValid()) throw new Error('`isSameOrAfter` expects date in YYYY-MM-DD format');
      return this.setRule('isSameOrAfter', date, (0, _helpers.cleanObject)({ message: message }));
    }
  }, {
    key: 'isBefore',
    value: function isBefore(beforeDate, message) {
      if (!(0, _moment2.default)(beforeDate, 'YYYY-MM-DD', true).isValid()) throw new Error('`isBefore` expects date in YYYY-MM-DD format');
      return this.setRule('isBefore', beforeDate, (0, _helpers.cleanObject)({ message: message }));
    }
  }, {
    key: 'isBeforeToday',
    value: function isBeforeToday(message) {
      return this.setRule('isBeforeToday', (0, _moment2.default)(new Date()).format('YYYY-MM-DD'), (0, _helpers.cleanObject)({ message: message }));
    }
  }, {
    key: 'isAfter',
    value: function isAfter(afterDate, message) {
      if (!(0, _moment2.default)(afterDate, 'YYYY-MM-DD', true).isValid()) throw new Error('`isAfter` expects date in YYYY-MM-DD format');
      return this.setRule('isAfter', afterDate, (0, _helpers.cleanObject)({ message: message }));
    }
  }, {
    key: 'isAfterToday',
    value: function isAfterToday(message) {
      return this.setRule('isAfterToday', (0, _moment2.default)(new Date()).format('YYYY-MM-DD'), (0, _helpers.cleanObject)({ message: message }));
    }
  }, {
    key: 'isMonday',
    value: function isMonday(message) {
      return this.setRule('isMonday', true, (0, _helpers.cleanObject)({ message: message }));
    }
  }, {
    key: 'isTuesday',
    value: function isTuesday(message) {
      return this.setRule('isTuesday', true, (0, _helpers.cleanObject)({ message: message }));
    }
  }, {
    key: 'isWednesday',
    value: function isWednesday(message) {
      return this.setRule('isWednesday', true, (0, _helpers.cleanObject)({ message: message }));
    }
  }, {
    key: 'isThursday',
    value: function isThursday(message) {
      return this.setRule('isThursday', true, (0, _helpers.cleanObject)({ message: message }));
    }
  }, {
    key: 'isFriday',
    value: function isFriday(message) {
      return this.setRule('isFriday', true, (0, _helpers.cleanObject)({ message: message }));
    }
  }, {
    key: 'isSaturday',
    value: function isSaturday(message) {
      return this.setRule('isSaturday', true, (0, _helpers.cleanObject)({ message: message }));
    }
  }, {
    key: 'isSunday',
    value: function isSunday(message) {
      return this.setRule('isSunday', true, (0, _helpers.cleanObject)({ message: message }));
    }
  }]);

  return DateRule;
}(_Any.AnyRule);

/****************************************
  Validator
*****************************************/

var DateValidator = function (_AnyValidator) {
  _inherits(DateValidator, _AnyValidator);

  function DateValidator() {
    _classCallCheck(this, DateValidator);

    return _possibleConstructorReturn(this, (DateValidator.__proto__ || Object.getPrototypeOf(DateValidator)).apply(this, arguments));
  }

  _createClass(DateValidator, [{
    key: 'type',
    value: function type(value, rule, options) {
      var valid = (0, _moment2.default)(value, options.format, true).isValid();
      return valid ? '' : 'Invalid date';
    }
  }, {
    key: 'isSame',
    value: function isSame(value, date, options) {
      var valid = (0, _moment2.default)(value, options.format, true).isSame(date);
      return valid ? '' : 'Must be ' + formatErrorDate(date);
    }
  }, {
    key: 'isSameOrBefore',
    value: function isSameOrBefore(value, date, options) {
      var valid = (0, _moment2.default)(value, options.format, true).isSameOrBefore(date);
      return valid ? '' : 'Must be the same or before ' + formatErrorDate(date);
    }
  }, {
    key: 'isSameOrAfter',
    value: function isSameOrAfter(value, date, options) {
      var valid = (0, _moment2.default)(value, options.format, true).isSameOrAfter(date);
      return valid ? '' : 'Must be the same or after ' + formatErrorDate(date);
    }
  }, {
    key: 'isBefore',
    value: function isBefore(value, beforeDate, options) {
      var valid = (0, _moment2.default)(value, options.format, true).isBefore(beforeDate);
      return valid ? '' : 'Must be before ' + formatErrorDate(beforeDate);
    }
  }, {
    key: 'isBeforeToday',
    value: function isBeforeToday(value, today, options) {
      var valid = (0, _moment2.default)(value, options.format, true).isBefore(today);
      return valid ? '' : 'Must be before today ' + formatErrorDate(today) + ')';
    }
  }, {
    key: 'isAfter',
    value: function isAfter(value, afterDate, options) {
      var valid = (0, _moment2.default)(value, options.format, true).isAfter(afterDate);
      return valid ? '' : 'Must be after ' + formatErrorDate(afterDate);
    }
  }, {
    key: 'isAfterToday',
    value: function isAfterToday(value, today, options) {
      var valid = (0, _moment2.default)(value, options.format, true).isAfter(today);
      return valid ? '' : 'Must be after today ' + formatErrorDate(today) + ')';
    }
  }, {
    key: 'isMonday',
    value: function isMonday(value, rule, options) {
      var valid = (0, _moment2.default)(value, options.format, true).format('dddd') === 'Monday';
      return valid ? '' : 'Must be a Monday';
    }
  }, {
    key: 'isTuesday',
    value: function isTuesday(value, rule, options) {
      var valid = (0, _moment2.default)(value, options.format, true).format('dddd') === 'Tuesday';
      return valid ? '' : 'Must be a Tuesday';
    }
  }, {
    key: 'isWednesday',
    value: function isWednesday(value, rule, options) {
      var valid = (0, _moment2.default)(value, options.format, true).format('dddd') === 'Wednesday';
      return valid ? '' : 'Must be a Wednesday';
    }
  }, {
    key: 'isThursday',
    value: function isThursday(value, rule, options) {
      var valid = (0, _moment2.default)(value, options.format, true).format('dddd') === 'Thursday';
      return valid ? '' : 'Must be a Thursday';
    }
  }, {
    key: 'isFriday',
    value: function isFriday(value, rule, options) {
      var valid = (0, _moment2.default)(value, options.format, true).format('dddd') === 'Friday';
      return valid ? '' : 'Must be a Friday';
    }
  }, {
    key: 'isSaturday',
    value: function isSaturday(value, rule, options) {
      var valid = (0, _moment2.default)(value, options.format, true).format('dddd') === 'Saturday';
      return valid ? '' : 'Must be a Saturday';
    }
  }, {
    key: 'isSunday',
    value: function isSunday(value, rule, options) {
      var valid = (0, _moment2.default)(value, options.format, true).format('dddd') === 'Sunday';
      return valid ? '' : 'Must be a Sunday';
    }
  }]);

  return DateValidator;
}(_Any.AnyValidator);

exports.DateRule = DateRule;
exports.DateValidator = DateValidator;